module.exports = __webpack_public_path__ + "img/game.8d699e41.svg";